import React from 'react';

import { Row, Text } from './styled/TelephonyIDStyled';

function TelephonyID(props: { value: string }) {
    const { value } = props;

    return (
        <div>
            <Row>
                <Text>{value}</Text>
            </Row>
        </div>
    );
}

export default TelephonyID;
